<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <div @click.stop>
        <div class="modal__header">
          <h2 class="modal__title">
            {{ $t('Error') }}
          </h2>
        </div>
        <div class="modal__header">
          {{ value }}
        </div>
        <div class="modal__buttons modal__header">
          <Button size="small" @click="show = false">
            {{ $t('Close') }}
          </Button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { VDialog, VCard } from 'vuetify/lib';
  import Button from '@/components/ui/Button';

  export default {
    name: 'ErrorDialog',
    components: {
      VDialog,
      Button,
      VCard,
    },
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: [String, Boolean],
    },
    computed: {
      show: {
        get() {
          return !!this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
  };
</script>
